module.exports = __webpack_public_path__ + "app/referentials/referential-config/referential-section-ctWrl_fW.html";